export const OOXML_Z_INDEX_BASE = 251658240;
